import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import { SvgIconProps } from '@mui/material';

export function MusicIcon(props: SvgIconProps) {
  return <PlayCircleIcon {...props} sx={{ color: '#1976d2' }} />;
}
